import React, { useEffect, useRef, useState } from 'react';
import {BrowserRouter as Router, Route, Switch, useHistory} from 'react-router-dom';
import 'antd/dist/antd.css';
import "video-react/dist/video-react.css"
import Login from './components/login';
import ProtectedRoute from './shared/components/protectedRoute';
import Contacts from './components/contacts';
import Call from './components/call';
import './styles/style-fonts.css';
import './styles/transition.scss';
import './styles/meetings.scss';
import Chats from './components/chat';
import CallMiniWindowScreen from './components/call/callsDialPad/callMiniWindow';
import { useSelector } from 'react-redux';
import { initialCallStateModel } from './models/callModel';
import './styles/index.scss';
import profile from './components/profile';
import SetNewPassword from './components/login/setNewPassword';
import MeetingMainFrame from './components/meeting';
import DBSuccess from './components/chat/chatWidgets/dropboxDriveStorage';
import OneDriveStorage from './components/chat/chatWidgets/oneDrive';
import 'animate.css';
import { Cookie, enableNotify, enablePermissionSafari, sleepDetect } from './base/utils';
import { SocketChatService } from './base/socketChatService';
import {  UserDetails, chatwindowDetails, contacts, loginReducerState, profileDetails, workContact } from './models/model';
import { LoginService } from './base/loginService';
import { generateChatID, loadScreen, userInfo } from './base/socketChatService/utils';
import store from './context/store/store';
import ChatNoInternet from './components/chat/chatsection/nointernet';
import ChatToastLeft from './components/chat/chatWidgets/toastScreenleft';
import { createCallConnection, currentCallEnd, initiateCall } from './base/callService/callService';
//import { openNotification } from './shared/widgets/pushNotification';
//import HomeEncryption from './common/homeEncryption';
//import InnerEncryption from './common/innerEncryption';
import { updateMeetingRead, updateMeetingTotalBatch } from "./base/meetingService/apiService";
import MeetingRoute from './components/meeting/meetingRoute';
import VideoCallScreenRight from './components/call/callsDialPad/imcomingVideocall';
import TeamCallHold from './components/call/teamCallHold';
import packageJson from "../package.json";
import { convertDurationSuggestions, determineIps, handleStopRecording, redirect, setAiAssist, storePlanValues } from './base/callService/common';
import VideoMeetRequestwindow from './components/call/callsDialPad/imcomingVideocall/videomeet';
import { ChatService } from './base/chatService';
import { getTemporyContactList } from './base/eventService/eventApiService';
import micAi from '../src/styles/images/mic_ai.svg';
import LandingPages from './components/chat/landingPage';
import BoxSuccess from './components/chat/chatWidgets/boxStorage/boxSuccessComponent';
import TourModal from './shared/components/tour';
import jwt_decode from "jwt-decode";
import EverNoteSuccess from './components/chat/chatWidgets/Evernote/EverNoteSuccessComponent';
import { Types } from './context/action/action';
import Privateappindex from './new pages/privateapp/privateappindex';
import _ from 'lodash';
import moment from "moment";
import { aiAssist } from './base/socketChatService/newChat';


function App() {
  const callState: initialCallStateModel = useSelector((state: initialCallStateModel) => state);
  const socketService = useRef<any>(null);
  const [isOffline, setOffline] = useState(false);
  const [tourKey, setTourKey] = useState(-1);
  const [displayText, setDisplayText] = useState("");
  const divRef = useRef<HTMLElement | any>(null);
  let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
  const {isAiAssist,isCaptureAi,aiRequest,list,arrayBuffer,intent}:any=store.getState().chatReducer;
  let { isRingvideo, isVideocallRingvideo}: profileDetails = useSelector((state: any) => state.profileReducer);
  let windowSearch:any = new URLSearchParams(window.location.search).get('call_number');
  
 if(windowSearch!== null) {
   localStorage.setItem('call_number',windowSearch);
 }
const caching= ()=> {
    let version = localStorage.getItem('version');
    console.log("version >>>>", version)
    console.log("packageJson.version >>>>", packageJson.version)
        if(version && version!== packageJson.version)
        {
              if('caches' in window){
/*               caches.keys().then((names) => {
              // Delete all the cache files
              names.forEach(name => {
              caches.delete(name);
              })
              }); */

              // Makes sure the page reloads. Changes are only visible after you refresh.
             
              window.location.reload();
              }
              //localStorage.clear();
              
        }
        localStorage.setItem('version',packageJson.version);
        let token_loggedUserDetails: any = store.getState().loginReducer.token || [];
        if(token_loggedUserDetails.length===0){
          ChatService.updateNavigation(true);
          setTimeout(()=>{
            ChatService.updateNavigation(false);
          },6000)
        }
    };

  useEffect(()=>{
    caching();
  },[document.location.href])

  useEffect(()=>{
    updateMeetingTotalBatch();
    //getTemporyContactList();
    if(navigator.userAgent.indexOf("Edg") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1)
    {
    //window.location.pathname !== '/login' && window.location.pathname !== '/' && enablePermission('appfile');
    }
    //window.location.pathname!=='/login'&& window.location.pathname!=='/chats' && findBrowser();
  
  },[]);

  const handleClickOutside=(e:any) =>{
    let icondiv:any=document.getElementById("aiicon");
     if(divRef.current && !divRef.current.contains(e.target) && icondiv && icondiv?.id!==(e.target?.id)){ if(isCaptureAi){ setAiAssist(false,false,"Listening...",{suggestions:[],error:"",prompt:""})
    handleStopRecording()}}
}

  useEffect(()=>{
     document.addEventListener('mousedown', handleClickOutside);
     return () => {
      document.removeEventListener('mousedown', handleClickOutside);
  };
  },[isAiAssist])
 

  useEffect(()=>{
    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess && userInfo["ssoToken"]){
      console.log("Socket inital Authentication-----------",new Date())
      const cookieData =JSON.parse(userInfosess);
      socketService.current= new SocketChatService(cookieData?.sip_login_id, cookieData?.domain_id);
      //const queryParams:contactSync = { ext: cookieData.ext, CallId: uuidv4()};
      socketService?.current?.getUserPrescence();
      socketService?.current?.getActiveGroupCalls();
      //socketService?.current?.getCallConnected();
      LoginService.createConnections(cookieData);
      loadScreen(true);
     // contactService.getWorkcontact(queryParams);
      storePlanValues();
    }
    Cookie.deleteKey('userinfo');
  },[]);


  const { incomingCallWindow, updatedCallList } = callState;


  /**
   * To handle call dialpad using keys
   */
  const keyHandler = (ev: any) => {
    let dialWindow = store.getState().updatedCallList || [];
    if ((dialWindow.rightSideWindow === "dialpad" && dialWindow.isWindowSlide) || dialWindow.minimizedWindow) {
      let activeElement: any = document.activeElement;
      let inputs = ['input', 'select', 'button', 'textarea'];
      let codes = [8, 13, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,187,96,97,98,99,100,101,102,103,104,105,107];
      if (activeElement && !inputs.includes((activeElement.tagName).toLowerCase()) && codes.includes(ev.keyCode)) {
        let number: string = '';
        switch (ev.keyCode) {
          case 8:
            number = 'Remove'
            break;
          case 13:
            number = 'Call'
            break;
          case 48:
            case 96:
            number = '0';
            break;
          case 49:
            case 97:
            number = '1';
            break;
          case 50:
            case 98:
            number = '2';
            break;
          case 51:
            case 99:
            number = '3';
            break;
          case 52:
            case 100:
            number = '4';
            break;
          case 53:
            case 101:
            number = '5';
            break;
          case 54:
            case 102:
            number = '6';
            break;
          case 55:
            case 103:
            number = '7';
            break;
          case 56:
            case 104:
            number = '8';
            break;
          case 57:
            case 105:
            number = '9';
            break;
            case 187:
              case 107:
            number = '+';
            break;
        }
        let dialId: any = document.getElementById(`dial${number}`);
        dialId?.click();}
    }

    };
      
  const handleOffline =()=>{
    setOffline(true);
  };

  const handleOnline=async ()=>{
    setOffline(false);
    try {
      const cookieData: any = Cookie.get();
      const userInfosess: any = sessionStorage.getItem("userinfo");
      if(cookieData&&userInfosess){
        let ipDetails:any= await determineIps();
        createCallConnection(JSON.parse(userInfosess),ipDetails.IP);}
  
    } catch (error) {
      console.log('cookieData error is ',error);     
    }
  };

  const handleTabClosing=()=>{
    currentCallEnd();
  }


    useEffect(() => {
     // window.location.pathname!=='/' && window.location.pathname!=='/login' && window.location.pathname==='/chats' && findBrowser();
      window.addEventListener("online",handleOnline);
      window.addEventListener("offline", handleOffline);
      window.addEventListener("beforeunload", handleTabClosing);

      sleepDetect()
    if (!updatedCallList.minimizedWindow) {
      window.addEventListener("keyup", (e: KeyboardEvent) => keyHandler(e));  
    }
      return () => {
        window.removeEventListener("keyup", keyHandler );
      };    
  }, []);

  const findBrowser= async ()=> {
    if(navigator.userAgent.indexOf("Edg") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1)
    {
      // const permissionName = "microphone" as PermissionName;
      // const permissioncameraName = "camera" as PermissionName;
      checkNotifyPermission();
      //checkAudioPermission(permissionName);
      //checkVideoPermission(permissioncameraName);
    }else {
      if(navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1)
      {
        let safrival= await enablePermissionSafari('leftsidebar');
        // console.log('safrival --------', safrival);
        //checkNotifyPermission();
        enableNotify(safrival?.setNotify);
        //enableAudioNotify(safrival?.setAudio);
        //enableVideoNotify(safrival?.setVideo);
      }
     } 
    }

  /**
   * To check audio permission
   */
  //  const checkAudioPermission = (type: PermissionName) => {
  //   navigator.permissions.query({ name: type })
  //     .then(permissionStatus => {
  //       let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
  //      enableAudioNotify(sts);
  //       permissionStatus.onchange = () => {
  //         let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
  //         enableAudioNotify(sts);
  //       };
  //     });
  // };
  
  // /**
  //    * To check video permission
  //    */
  //  const checkVideoPermission = (type: PermissionName) => {
  //   navigator.permissions.query({ name: type })
  //     .then(permissionStatus => {
  //      // permissionStatus.state==='denied'?setVideoPermission(true):permissionStatus.state==='granted'?setVideoPermission(true):setVideoPermission(false)
  //       let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
  //       enableVideoNotify(sts);
  //       permissionStatus.onchange = () => {
  //         let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
  //         enableVideoNotify(sts);
  
  //       };
  //     });
  // };
   
  /**
   * To check notification permission
   */
   const checkNotifyPermission=async ()=>{
    if (("Notification" in window)) {
      await Notification.requestPermission().then(function(permission) {
        console.log(permission,"permission")
      let notfy = permission==='granted'?  true : permission ==='denied'?  true : false
      enableNotify(notfy);
    });
    }
  }
  
    /**
       * To enable notification & mic permission
       */
  
    //  const BrowserenablePermission = async () =>{
    //   if(navigator.userAgent.indexOf("Edg") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1)
    // {
    //   const permissionName = "microphone" as PermissionName;
    //   const permissioncameraName = "camera" as PermissionName;
    //   checkNotifyPermission();
    //   checkAudioPermission(permissionName);
    //   checkVideoPermission(permissioncameraName);
    //   enablePermission('leftsidebar');
    // }else {
    //   if(navigator.userAgent.indexOf("Safari") !== -1)
    //     {
    //       window.location.reload();
    //     }
    // }
    //  }

    /**
       * To Manage the tour keys
       */
  
    const managekeys=(keys:number)=>{ 
      setTourKey(keys)
    }
  const cookieData: any = Cookie.get();

  useEffect(() => {
    if(cookieData.ssoToken){
      var decoded: any = jwt_decode(cookieData.ssoToken);
      console.log('-----decoded-----', decoded)
      if (decoded) {
      if (decoded.is_tour_flag === 0 && (cookieData.startTour !== '1' || cookieData.startTour === undefined)) {
          Cookie.set('startTour', '0', 365);
          setTourKey(1)
        };
      }
    }
  
  }, [cookieData.startTour === '0' || window.location.pathname === '/chats']);

  useEffect(() => {
    if(cookieData.ssoToken){
      var decoded: any = jwt_decode(cookieData.ssoToken);
      console.log('-----decoded-----123456789', decoded)
      if (decoded) {
        store.dispatch({
          type: Types.SSO_TOKEN_CLIENT_DOMAIN,
          payload: {
            clientDomain: decoded.client_domain
          }
        });
      }
    }
  
  }, [cookieData.ssoToken]);



  const initiateAudioCall=(ele:any)=>{
    const {aiRequest,isAiAssist,isCaptureAi,list}:any=store.getState().chatReducer;
    setAiAssist(isAiAssist,isCaptureAi,`Calling ${ele.name}`,{suggestions:[],prompt:"",error:""})
    setTimeout(()=>{
      setAiAssist(false,false,"",{suggestions:[],prompt:"",error:""});
      initiateCall(ele.ext,"audio");
    },3000)

  }

  useEffect(()=>{
    let index = 0;
    let timeout:any;
    const typeLetter = () => {
        if (index < aiRequest.length) {
          if(index > 0){setDisplayText((prev:any) => prev + aiRequest[index]);}else{setDisplayText(aiRequest[index])}
          index++;
         timeout =setTimeout(typeLetter, 50);
        }
        else if(index === aiRequest.length)
        {
          clearTimeout(timeout);
          index = 0;
        }
      

    };
    if(aiRequest.trim() !=="" && aiRequest !=="Listening..."){
    typeLetter(); // Start the recursive typing effect
    }
    else if(aiRequest.trim() !=="" && aiRequest ==="Listening..."){
      setDisplayText("Listening...")
    }
    return () => {
      if(aiRequest.trim() !=="" && aiRequest !=="Listening..."){
        console.log("rettttyt")
        clearTimeout(timeout);
        index = aiRequest.length;
        }  
    };

  },[list.suggestions?.length,aiRequest,isAiAssist,isCaptureAi,intent,list.prompt])

  const sendChat=(ele:any)=>{
    let { userdetails }: loginReducerState = store.getState().loginReducer;
    const {aiAssistMessage}:any=store.getState().chatReducer;
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    let   contactDetail:any = _.find(companyContact, function (o) {
      return (o.ext === ele.ext)
    });
  store.dispatch({
      type:Types.SET_CONTACT_WINDOW,
      payload:{chatWindowDetails:contactDetail}
  })
  const socketservice = new SocketChatService(userdetails?.sip_login_id, userdetails?.domain_id);
  const userDetails = userInfo();
  console.log(userDetails.fromID,"userDetails")
  const id:any=generateChatID(userDetails.fromID, ele.sipid)
  setTimeout(()=>{
      store.dispatch({
          type:Types.SET_ARR_BUFFER,
          payload:{
            aiSessionId:"",
            arrayBuffer:[],
            intent:"send_message",
            aiAssistMessage:aiAssistMessage
          }
        })
      },3000)
      socketservice.openChatWindow(contactDetail,"",{chatId:id});
      setAiAssist(false,false,"", {suggestions:[],prompt:"",error:""});
  }


  return (
    <div className="App">
      <Router>
        {/* {(incomingCallWindow.status && window.location.pathname !== '/login') &&
          <IncomingCallDetail incomingDetail={incomingCallWindow.incomingCallDetail}></IncomingCallDetail>} */}
         {updatedCallList.isTeamCallHold === true && <TeamCallHold holdTeamCall= {updatedCallList}></TeamCallHold>}
        {((incomingCallWindow.status ? incomingCallWindow.status : updatedCallList.minimizedWindow) && window.location.pathname !== '/login') && <CallMiniWindowScreen></CallMiniWindowScreen> }
        {window.location.pathname !== '/login'&& <TourModal  managekeys={managekeys} tourKey={tourKey}></TourModal>}
        {isRingvideo &&  <VideoCallScreenRight />}
        {isVideocallRingvideo &&  <VideoMeetRequestwindow />}
        {/* {!iaAiAssist ?
         <div className='blinkingdiv' >
           <div className='blinkingdivmicsection'  onClick={!isRecording ? startCapture : stopCapture}>
               <div className='magicmicsectionn'>
               <img src={micAi} alt="" />
              </div>
               <p>Speak now</p>
            </div>
            <div className='blinkingdivbtnsection'>
               <div className='btnblink'>
                <p> refer to one or some of a thing </p>
               </div>
               <div className='btnblink'>
                <p> refer to one or some of a thing </p>
               </div>
               <div className='btnblink'>
                <p> refer to one or some of a thing </p>
               </div>
               <div className='btnblink'>
                <p> refer to one or some of a thing </p>
               </div>
            </div>


           <div>
            </div>  
        </div> */}

       {cookieData.ssoToken && isCaptureAi && 
       <><div className='blinkingdiv1' ref={divRef}>
       <p>{displayText}</p>
       {list.suggestions && list["suggestions"]?.length > 0 && intent === "make_a_Call" && list["suggestions"]?.map((ele:any,index:any)=>{
          return (
            <div className='meetingsectionn'  key={index}>
                <div className="meetingsecdivv"> 
                <div className='meetingsecdivcolone'> 
                  <p>{ele.name}</p>
                  <div className='meetingsectioniconsflexcon'>
                    <div>
                      <p> <span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M7.99836 2.34724C11.1217 2.34724 13.6627 4.88818 13.6627 8.01155C13.6627 11.1349 11.1217 13.6759 7.99836 13.6759C4.87506 13.6759 2.33406 11.1349 2.33406 8.01155C2.33406 4.88818 4.87506 2.34724 7.99836 2.34724ZM7.99836 1.34766C4.31803 1.34766 1.33447 4.33115 1.33447 8.01155C1.33447 11.6919 4.31803 14.6754 7.99836 14.6754C11.6787 14.6754 14.6623 11.6919 14.6623 8.01155C14.6623 4.33115 11.6788 1.34766 7.99836 1.34766Z" fill="#AAABAD"/>
  <path d="M9.33561 8.57918C9.22052 8.55039 9.0999 8.57711 8.99621 8.63475C8.59691 8.85679 8.11318 8.94456 7.60413 8.83221C7.41347 8.79009 7.23488 8.71879 7.07115 8.62483C6.96686 8.56498 6.84458 8.53653 6.72776 8.56498C5.7499 8.80322 4.9515 9.30767 4.51208 9.95527C4.40646 10.1109 4.40786 10.3133 4.51315 10.4691C5.00548 11.1982 5.95361 11.7413 7.11306 11.9198C9.03406 12.2158 10.779 11.5116 11.4979 10.4112C11.5843 10.2789 11.5849 10.1011 11.4987 9.9686C11.0787 9.32247 10.3009 8.82088 9.33561 8.57918Z" fill="#AAABAD"/>
  <path d="M9.34883 7.32688C10.1085 6.56723 10.1171 5.34428 9.3682 4.59533C8.61925 3.84638 7.39629 3.85505 6.63665 4.6147C5.87701 5.37434 5.86834 6.5973 6.61728 7.34624C7.36623 8.09519 8.58919 8.08652 9.34883 7.32688Z" fill="#AAABAD"/>
</svg></span>In a meeting</p>
                    </div>

                  </div>
                  </div> 
                  <div>{ele.ext}</div>
                  <div className='meetingsecdivcoltwo' onClick={()=>initiateAudioCall(ele)}>
                    <button>Make a call</button>
                   </div> 
                </div>
                </div>)})}
                {list.suggestions && list["suggestions"]?.length > 0 && intent === "send_a_Message" && list["suggestions"]?.map((ele:any,index:any)=>{
          return (
            <div className='meetingsectionn'  key={index}>
                <div className="meetingsecdivv"> 
                <div className='meetingsecdivcolone'> 
                  <p>{ele.name}</p>
                  <div className='meetingsectioniconsflexcon'>
                    <div>
                      <p> <span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M7.99836 2.34724C11.1217 2.34724 13.6627 4.88818 13.6627 8.01155C13.6627 11.1349 11.1217 13.6759 7.99836 13.6759C4.87506 13.6759 2.33406 11.1349 2.33406 8.01155C2.33406 4.88818 4.87506 2.34724 7.99836 2.34724ZM7.99836 1.34766C4.31803 1.34766 1.33447 4.33115 1.33447 8.01155C1.33447 11.6919 4.31803 14.6754 7.99836 14.6754C11.6787 14.6754 14.6623 11.6919 14.6623 8.01155C14.6623 4.33115 11.6788 1.34766 7.99836 1.34766Z" fill="#AAABAD"/>
  <path d="M9.33561 8.57918C9.22052 8.55039 9.0999 8.57711 8.99621 8.63475C8.59691 8.85679 8.11318 8.94456 7.60413 8.83221C7.41347 8.79009 7.23488 8.71879 7.07115 8.62483C6.96686 8.56498 6.84458 8.53653 6.72776 8.56498C5.7499 8.80322 4.9515 9.30767 4.51208 9.95527C4.40646 10.1109 4.40786 10.3133 4.51315 10.4691C5.00548 11.1982 5.95361 11.7413 7.11306 11.9198C9.03406 12.2158 10.779 11.5116 11.4979 10.4112C11.5843 10.2789 11.5849 10.1011 11.4987 9.9686C11.0787 9.32247 10.3009 8.82088 9.33561 8.57918Z" fill="#AAABAD"/>
  <path d="M9.34883 7.32688C10.1085 6.56723 10.1171 5.34428 9.3682 4.59533C8.61925 3.84638 7.39629 3.85505 6.63665 4.6147C5.87701 5.37434 5.86834 6.5973 6.61728 7.34624C7.36623 8.09519 8.58919 8.08652 9.34883 7.32688Z" fill="#AAABAD"/>
</svg></span>In a meeting</p>
                    </div>

                  </div>
                  </div> 
                  <div>{ele.ext}</div>
                  <div className='meetingsecdivcoltwo' onClick={()=>sendChat(ele)}>
                    <button>Send Message</button>
                   </div> 
                </div>
                </div>)})}
                {list.suggestions && list["suggestions"]?.length > 0 && intent === "meeting_available" && 
           list["suggestions"]?.map((ele:any,idx:any)=>{
           return(<div className='meetingsectionn' key={idx}>
           <div className="meetingsecdivv"> 
           <div className='meetingsecdivcolone'> 
             <p>{ele.meeting_title}</p>  
             <div className='meetingsectioniconsflexcon'>
               <div>
                 <p> <span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M7.99836 2.34724C11.1217 2.34724 13.6627 4.88818 13.6627 8.01155C13.6627 11.1349 11.1217 13.6759 7.99836 13.6759C4.87506 13.6759 2.33406 11.1349 2.33406 8.01155C2.33406 4.88818 4.87506 2.34724 7.99836 2.34724ZM7.99836 1.34766C4.31803 1.34766 1.33447 4.33115 1.33447 8.01155C1.33447 11.6919 4.31803 14.6754 7.99836 14.6754C11.6787 14.6754 14.6623 11.6919 14.6623 8.01155C14.6623 4.33115 11.6788 1.34766 7.99836 1.34766Z" fill="#AAABAD"/>
<path d="M9.33561 8.57918C9.22052 8.55039 9.0999 8.57711 8.99621 8.63475C8.59691 8.85679 8.11318 8.94456 7.60413 8.83221C7.41347 8.79009 7.23488 8.71879 7.07115 8.62483C6.96686 8.56498 6.84458 8.53653 6.72776 8.56498C5.7499 8.80322 4.9515 9.30767 4.51208 9.95527C4.40646 10.1109 4.40786 10.3133 4.51315 10.4691C5.00548 11.1982 5.95361 11.7413 7.11306 11.9198C9.03406 12.2158 10.779 11.5116 11.4979 10.4112C11.5843 10.2789 11.5849 10.1011 11.4987 9.9686C11.0787 9.32247 10.3009 8.82088 9.33561 8.57918Z" fill="#AAABAD"/>
<path d="M9.34883 7.32688C10.1085 6.56723 10.1171 5.34428 9.3682 4.59533C8.61925 3.84638 7.39629 3.85505 6.63665 4.6147C5.87701 5.37434 5.86834 6.5973 6.61728 7.34624C7.36623 8.09519 8.58919 8.08652 9.34883 7.32688Z" fill="#AAABAD"/>
</svg></span>{ele.host_name}</p>
               </div>
               <div>
                 <p> <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M6.99992 0.333984C3.33325 0.333984 0.333252 3.33398 0.333252 7.00065C0.333252 10.6673 3.33325 13.6673 6.99992 13.6673C10.6666 13.6673 13.6666 10.6673 13.6666 7.00065C13.6666 3.33398 10.6666 0.333984 6.99992 0.333984ZM6.99992 12.6673C3.86659 12.6673 1.33325 10.134 1.33325 7.00065C1.33325 3.86732 3.86659 1.33398 6.99992 1.33398C10.1333 1.33398 12.6666 3.86732 12.6666 7.00065C12.6666 10.134 10.1333 12.6673 6.99992 12.6673Z" fill="#AAABAD"/>
<path d="M6.99992 2.26732C6.73325 2.26732 6.46658 2.46732 6.46658 2.80065V6.20065C6.46658 6.40065 6.33325 6.53398 6.13325 6.53398H3.46658C3.19992 6.53398 2.93325 6.73398 2.93325 7.06732C2.93325 7.40065 3.13325 7.60065 3.46658 7.60065H6.13325C6.86658 7.60065 7.46658 7.00065 7.46658 6.26732V2.73398C7.53325 2.46732 7.26658 2.26732 6.99992 2.26732Z" fill="#AAABAD"/>
</svg></span>{`${  (moment(ele.start_timestamp).format('hh:mm A'))} - ${  (moment(ele.end_timestamp).format('hh:mm A'))}`}</p>
               </div>
               <div>
                 <p>
                   <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M7.99836 2.34724C11.1217 2.34724 13.6627 4.88818 13.6627 8.01155C13.6627 11.1349 11.1217 13.6759 7.99836 13.6759C4.87506 13.6759 2.33406 11.1349 2.33406 8.01155C2.33406 4.88818 4.87506 2.34724 7.99836 2.34724ZM7.99836 1.34766C4.31803 1.34766 1.33447 4.33115 1.33447 8.01155C1.33447 11.6919 4.31803 14.6754 7.99836 14.6754C11.6787 14.6754 14.6623 11.6919 14.6623 8.01155C14.6623 4.33115 11.6788 1.34766 7.99836 1.34766Z" fill="#AAABAD"/>
<path d="M9.33561 8.57918C9.22052 8.55039 9.0999 8.57711 8.99621 8.63475C8.59691 8.85679 8.11318 8.94456 7.60413 8.83221C7.41347 8.79009 7.23488 8.71879 7.07115 8.62483C6.96686 8.56498 6.84458 8.53653 6.72776 8.56498C5.7499 8.80322 4.9515 9.30767 4.51208 9.95527C4.40646 10.1109 4.40786 10.3133 4.51315 10.4691C5.00548 11.1982 5.95361 11.7413 7.11306 11.9198C9.03406 12.2158 10.779 11.5116 11.4979 10.4112C11.5843 10.2789 11.5849 10.1011 11.4987 9.9686C11.0787 9.32247 10.3009 8.82088 9.33561 8.57918Z" fill="#AAABAD"/>
<path d="M9.34883 7.32688C10.1085 6.56723 10.1171 5.34428 9.3682 4.59533C8.61925 3.84638 7.39629 3.85505 6.63665 4.6147C5.87701 5.37434 5.86834 6.5973 6.61728 7.34624C7.36623 8.09519 8.58919 8.08652 9.34883 7.32688Z" fill="#AAABAD"/>
</svg></span>
                   {convertDurationSuggestions(ele.duration_minutes)}
                 </p>
               </div>
             </div>
             </div> 
             <div className='meetingsecdivcoltwo'>
               <button onClick={()=>redirect(ele)}>Join meeting</button>
              </div> 
           </div>
          </div>)}) 
}
       </div>
</>
       }

        {/* <LandingPages fromComponent={"Message"} icon={"messagEncypt"} ></LandingPages> */}
        <Switch>
          {/* <Route path='/protected' element={Protected}/> */}
          <Route path='/' exact component={Login} />
          <Route path='/login' exact component={Login} />
          <Route path='/reset' exact component={SetNewPassword} />
          <Route path="/box/callback" exact component={BoxSuccess} />
          <Route path="/evernote/success" exact component={EverNoteSuccess} />
          <ProtectedRoute path='/dbsuccess' exact component={DBSuccess} />
          <ProtectedRoute path="/onedrivestatus" exact component={OneDriveStorage} />
          <ProtectedRoute path="/contacts" component={Contacts} />
          <ProtectedRoute path="/home" component={LandingPages} />
          <ProtectedRoute path="/calls" component={Call}/>
          <ProtectedRoute path="/chats" component={Chats} />
          <ProtectedRoute path="/profile" component={profile} />
          <ProtectedRoute path="/meeting" component={MeetingMainFrame} />
          <ProtectedRoute path="/meetingDetails" component={MeetingRoute}/>
          <ProtectedRoute path="/privateappindex" component={Privateappindex}/>
        </Switch>
      
      </Router>
 

      <div className="hoverDivFreez" id="frezsec"></div>
      {/* <HomeEncryption /> */}
      {/* <InnerEncryption /> */}
      {/* {(!gotNotifyPermission||!gotAudioPermission ||!gotVideoPermission)&&(window.location.pathname!=='/login') && (window.location.pathname !== '/') &&<NotificationBottom closeNotification={closeNotification} enablePermission={enablePermission} />} */}
      {isOffline&&<><ChatNoInternet></ChatNoInternet>
      <ChatToastLeft></ChatToastLeft>
      </>}
    </div>
  );
}

export default React.memo(App);
function decodeJWT(token: any): any {
  throw new Error('Function not implemented.');
}

